import type { HotkeysMapProps } from './components/HotkeysMap';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "HotkeysMap" */ './lazyIndex'),
    { name: 'HotkeysMap' }
);

export { default as setIsHotkeysMapVisible } from './actions/setIsHotkeysMapVisible';

export type { CommandCategory } from './components/CommandCategory';

export const lazyLaunchHotkeysMap: LazyAction<
    typeof lazyIndex.launchHotkeysMap,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.launchHotkeysMap);
export const lazyUpdateHotkeysMapStore: LazyAction<
    typeof lazyIndex.updateHotkeysMapStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateHotkeysMapStore);

export const HotkeysMap: LazyComponent<HotkeysMapProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.HotkeysMap
);
